export const primaryButtonText = {
  es: "Continuar",
  en: "Continue",
};

export const secondaryButtonText = {
  es: "Volver",
  en: "Back",
};

export const tertiaryButtonText = {
  es: "Volver",
  en: "Back",
};
